/**
 * 점검결과 상태 변환 유틸리티
 */

export const RESULT_STATUS = {
  O: '적합',
  X: '미흡',
  '/': '해당없음',
} as const;

export type ResultStatusType = keyof typeof RESULT_STATUS;

/**
 * 점검결과 상태를 한글로 변환
 * @param status - 점검결과 상태 (O, X, /)
 * @returns 한글 상태명
 */
export const translateResultStatus = (status: string): string => {
  return RESULT_STATUS[status as ResultStatusType] || status;
};

/**
 * 점검결과 상태가 적합인지 확인
 * @param status - 점검결과 상태
 * @returns 적합 여부
 */
export const isResultSuitable = (status: string): boolean => {
  return status === 'O';
};

/**
 * 점검결과 상태가 미흡인지 확인
 * @param status - 점검결과 상태
 * @returns 미흡 여부
 */
export const isResultInsufficient = (status: string): boolean => {
  return status === 'X';
};

/**
 * 점검결과 상태가 해당없음인지 확인
 * @param status - 점검결과 상태
 * @returns 해당없음 여부
 */
export const isResultNotApplicable = (status: string): boolean => {
  return status === '/';
};

